import React from 'react';
import Header from './components/Header';
import HeroSection from './components/homepage/HeroSection';
import TrustBadges from './components/homepage/TrustBadges';
import WhyChooseUs from './components/homepage/WhyChooseUs';
import TestimonialsCarousel from './components/homepage/TestimonialsCarousel';
import ServicesPreview from './components/homepage/ServicesPreview';
import CTASection from './components/homepage/CTASection';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="bg-sand-50 min-h-screen text-sand-900">
      <Header />
      <main>
        <HeroSection />
        <TrustBadges />
        <WhyChooseUs />
        <TestimonialsCarousel />
        <ServicesPreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default App;
